import { defaultSchema, type Options } from 'rehype-sanitize';

// The default schema drops `data:` image sources; rehypeBlockExternalImages then keeps raster data images only.
export const markdownSanitizeSchema: Options = {
    ...defaultSchema,
    protocols: {
        ...defaultSchema.protocols,
        src: [...(defaultSchema.protocols?.src ?? []), 'data'],
    },
};
